import moment from 'moment';
import { isNil, size } from 'lodash-es';
import getCountryISO2 from 'country-iso-3-to-2';
export const isStartTestReady = (user) => {
    if (!user)
        return false;
    const requiredKeys = ['firstName', 'lastName', 'email', 'countryOfCitizenship'];
    let flag = false;
    for (const key of requiredKeys) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (!user[key]) {
            flag = false;
            break;
        }
        else {
            flag = true;
        }
    }
    return flag;
};
export function isMac() {
    return navigator.platform.indexOf('Mac') > -1;
}
export const countryISO3ToISO2 = (iso3Country) => {
    return iso3Country?.length === 3 ? getCountryISO2(iso3Country) : iso3Country;
};
export const formatCurrency = (amount, currency = 'USD', fractionDigits = 0) => {
    const effectiveCurrencyCode = typeof currency === 'string' ? currency : currency.code;
    const effectiveFractionDigits = fractionDigits || typeof currency === 'string' ? fractionDigits : currency.fractionDigits;
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: effectiveCurrencyCode
    }).format(amount / 10 ** effectiveFractionDigits);
};
export const formatDate = (date, format) => {
    return moment(date).isValid() ? moment(date).format(format) : '';
};
export const scrollToElement = (id, offset = 0) => {
    const element = document.getElementById(id);
    if (element) {
        const y = element.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
    }
};
// Regula recommends the following minimum resolution for an ID photo
export const idVerificationMinWidth = 1920;
export const idVerificationMinHeight = 1080;
export const hasSkills = (skills) => !isNil(skills) && size(skills) > 0;
export var DateFormat;
(function (DateFormat) {
    DateFormat["DEFAULT"] = "DD MMMM yyyy";
})(DateFormat || (DateFormat = {}));
export const downloadApp = () => {
    const MAC_URL = `${process.env.REACT_APP_PESC_URL}${process.env.REACT_APP_PESC_DOWNLOAD_DMG_MAC_PATH}`;
    const MSI_URL = `${process.env.REACT_APP_PESC_URL}${process.env.REACT_APP_PESC_DOWNLOAD_MSI_PATH}`;
    if (!MSI_URL || !MAC_URL)
        return;
    window.open(isMac() ? MAC_URL : MSI_URL, '_self');
};
export const hexWithOpacity = (hex, opacity) => {
    const alpha = Math.round(Math.min(Math.max(opacity, 0), 1) * 255);
    const alphaHex = alpha.toString(16).padStart(2, '0').toUpperCase();
    return hex + alphaHex;
};
//# sourceMappingURL=utils.js.map